import { TranslateModule } from '@ngx-translate/core';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';

import { MwCoreToolbarModule } from 'app/@shared/@components/core-toolbar/core-toolbar.module';
import { NotificationBannerModule } from '../notification-banner';
import { MwAppToolbarApiService } from './app-toolbar-api.service';
import { MwAppToolbarComponent } from './app-toolbar.component';
import { MwAppToolbarService } from './app-toolbar.service';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MwCoreToolbarModule,
    TranslateModule,
    NotificationBannerModule,
  ],
  declarations: [MwAppToolbarComponent],
  exports: [MwAppToolbarComponent],
  providers: [MwAppToolbarService, MwAppToolbarApiService],
})
export class MwAppToolbarModule {}
